import { useInfiniteQuery } from '@tanstack/react-query';

import TimelineClient from '@clients/timelineClient';
import notifyAPIError from '@utils/notifyAPIError';

const { getTimeline } = TimelineClient();

export type TimelineProps = {
    accountId: string;
    pageSize?: number;
    itemsPerPage?: number;
    nextCursor?: string;
    timelineDateStart?: string;
    timelineDateEnd?: string;
    timelineType?: string;
    categoryType?: string;
};

const useGetTimeline = ({
    accountId,
    itemsPerPage = 30,
    nextCursor = null,
    timelineDateStart,
    timelineDateEnd,
    timelineType,
    categoryType,
}: TimelineProps) => {
    const {
        data,
        error,
        isError,
        isLoading,
        fetchNextPage,
        hasNextPage,
        refetch,
    } = useInfiniteQuery(
        [
            'timelineDetails',
            accountId,
            nextCursor,
            timelineDateStart,
            timelineDateEnd,
            timelineType,
            categoryType,
        ],
        ({ pageParam }) =>
            getTimeline({
                accountId: parseFloat(accountId),
                next_cursor: nextCursor || pageParam,
                pageSize: itemsPerPage,
                timelineDateStart,
                timelineDateEnd,
                timelineType,
                categoryType,
            }),
        {
            getNextPageParam: (lastPage) => lastPage.next_cursor ?? undefined,
            onError: notifyAPIError,
        },
    );

    return {
        data,
        error,
        isError,
        isLoading,
        fetchNextPage,
        hasNextPage,
        refetch,
    };
};

export default useGetTimeline;
